var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoggedIn && _vm.$route.name !== 'PrintPage' && _vm.$route.name !== 'Child')?_c('v-app',{attrs:{"id":"inspire"}},[_c('sidebar')],1):_c('v-app',[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }